export class PastOrUpcomingEventReservationsRequestDTO {
  constructor (
    public venueId: string,
    public eventId?: string,
  ) {}
}
